
import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useForm } from "react-hook-form";
import SectionTitle from "../../component/SectionTitle";
import { Redirect } from "react-router-dom";
import LoaderSpinner from "../../component/LoaderSpinner";
import { useHistory } from "react-router-dom";

const VerifyEmail = (props) => {
  const [redirect, setRedirect] = useState(false);
  const history = useHistory();
  const {
    userDetails,
    verifyEmailContext,
    userResendVerifyCode,
    isAuthenticated,
    loader,
  } = useContext(AuthContext);
  const [userEmail, setUserEmail] = useState(userDetails.email);
  const [verified, setVerified] = useState(userDetails.email_verified_at);
  const { register, handleSubmit, errors } = useForm();

  const verifyUserEmail = async (values) => {
    let response = await verifyEmailContext(values);
    console.log({ response });
    if (response) {
      history.push("/profile");
    }
  };

  const resendOtpCode = (e) => {
    e.preventDefault();
    userResendVerifyCode(userEmail);
  };

  useEffect(() => {
    setVerified(userDetails.email_verified_at);
  }, [userDetails.email_verified_at]);

  return (
    <React.Fragment>
      {loader ? (
        <div className="section-full p-t120  p-b60 site-bg-light pattern-bg">
          <div className="container mx-auto">
            <LoaderSpinner />
          </div>
        </div>
      ) : (
        <div className="section-full p-t120  p-b60 site-bg-light pattern-bg">
          {verified !== null ? (
            <Redirect to="/profile?tab=dashboard" />
          ) : (
            <div>
              {isAuthenticated ? (
                <div className="container">
                  <div className="row">
                    <div className="col-xl-8 col-lg-7 col-md-6">
                      <div className="twm-log-reg-form-wrap mt-0">
                        <SectionTitle lower="Verify Email" align="center" />
                        <form onSubmit={handleSubmit(verifyUserEmail)}>
                          <div className="twm-login-candidate">
                            <input
                              type="hidden"
                              name="email"
                              className="form-control"
                              defaultValue={userEmail}
                              ref={register}
                            />
                            
                            <p htmlFor="otp_code" className="text-write text-base text-center otp_code">
                              An email has been sent to <b>{userEmail}</b>, use
                              the <mark>Code</mark> provided in the{" "}
                              <mark>Email</mark> to verify your account.
                            </p>
                            <div className="text-center">
                              <div className="form-group">
                                <div class="otp-input-wrapper">
                                <input
                                    style={{
                                      border:
                                        errors.otp_code && "1px solid #ff0000",
                                    }}
                                    type="text"
                                    maxLength="4"
                                    autoComplete="off"
                                    name="otp_code"
                                    id="otp_code"
                                    placeholder=""
                                    autoFocus={true}
                                    ref={register({
                                      required: "Required",
                                    })}
                                  />
                                  <svg
                                    viewBox="0 0 180 1"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <line
                                      x1="0"
                                      y1="0"
                                      x2="175"
                                      y2="0"
                                      stroke="#3e3e3e"
                                      strokeWidth="2"
                                      strokeDasharray="44,22"
                                    />
                                  </svg>

                                </div>
                              </div>
                              <button className="site-button" type="submit">
                                Verify
                              </button>
                            </div>
                          </div>
                        </form>
                        <br />
                        <div className="text-center">
                          <p>
                            If you did not receive the email click on the resend
                            button
                          </p>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={resendOtpCode}
                          >
                            Resend Email
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-5 col-md-6">
                      <figure className="account-image">
                        <img src="/portal/images/login.png" alt="info image" />
                      </figure>
                    </div>
                  </div>
                </div>
              ) : (
                <Redirect to="/" />
              )}
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default VerifyEmail;
